var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlitzquizQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.89 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "progstroke",
    d: "M99.06,107.39,112,131.47H59.51l-4.93-9.21c-30-1.94-51.69-23.66-51.69-53.18C2.89,38.28,26.72,15.9,59,15.9s56.08,22.38,56.08,53.18C115.05,84.58,109.08,97.92,99.06,107.39ZM50.91,69.08a7.91,7.91,0,0,0,8,8.14A8,8,0,0,0,67,69.08a7.91,7.91,0,0,0-8.13-8A7.79,7.79,0,0,0,50.91,69.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitzquizQ);
export default __webpack_public_path__ + "static/media/glitzquiz-q.4cd157f6ababa69e86b7d5ff4f2c15f8.svg";
export { ForwardRef as ReactComponent };